import React from 'react';
import Table from './Table'
import Loading from './Loading'
import {Requestdynamic} from '../../Network/Fetch';
import PopUp from './PopUp'
import Cookies from 'universal-cookie'
import Header from './Header'
import ModalDeleteUser from './PopUpDelete'
import ExcelFile from './ExportExcelFile'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {SimpleButton} from './Style'
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import {TransformDateToUnixTime} from '../../Moment/Moment';


class AllNoneMember extends React.Component {
  constructor(props){
      super(props);
      this.state = {
        member: [],
        memberDisplay: [],
        searchMember: [],
        loadingMore: false,
        openModal: false,
        title: null,
        message: null,
        search: null,
        Filter: [],
        searchMemberRegion: [],
        searchRegion: false,
        statusDelete: null,
        delete: false,
        MemberDelete: null,
        sortFilter: {
          FirstName: "up",
          LastName: "up",
          Email: 'up',
          Society: "up",
          AccountCreatedAt: "up",
          Region: "up",
          Source: 'up',
          Tel: 'up'
        }
      }
    }


    MemberDisplayRegistration = () => {
      var Copy, Display
      if (this.state.Filter.length === 0)
      {
         Copy = [...this.state.member];
         Display = Copy.slice(0, 20)
        this.setState({memberDisplay: Display, searchMemberRegion: [], searchRegion: false})
        return ;
      }
       Copy = [...this.state.member]
      var FilterResult = Copy.filter(res => this.state.Filter.find(region => region === res.Region))
       Display = FilterResult.slice(0, 20)
      this.setState({searchRegion: true, memberDisplay: Display, searchMemberRegion: FilterResult})
    }

    _sortByAlphabet = (Name) => {
      var Verify = ""
      if (this.state.searchRegion === true)
        Verify = "searchMemberRegion"
      else
        Verify = "member"

      var Copy = [...this.state[Verify]];
      var NameSortFilter = this.state.sortFilter[Name]
      var SortedResult = Copy.sort(function(a, b){
        var nameA, nameB;
        if (!a[Name])
          a[Name] = ''
        if (!b[Name])
          b[Name] = ''
        if (Name === "Cotisation")
        {
          nameA = a.Cotisation === true ? 'oui' : 'non'
          nameB = b.Cotisation === true ? 'oui' : 'non'
        }
        else if (Name ===  "AccountCreatedAt")
        {
           nameA = TransformDateToUnixTime(a.AccountCreatedAt, 'DD/MM/YYYY')
           nameB = TransformDateToUnixTime(b.AccountCreatedAt, 'DD/MM/YYYY')
           if (!nameA)
            nameA = ""
           if (!nameB)
            nameB = ""
        }
        else {
           nameA = a[Name].toLowerCase()
           nameB = b[Name].toLowerCase();
        }
           if (nameA < nameB) //sort string ascending
            return -1;
         return 0; //default return value (no sorting)
        });
      if (NameSortFilter === 'down')
        SortedResult = SortedResult.reverse()
      var Display = SortedResult.slice(0, 20);
      var sortOrder = Object.assign({}, this.state.sortFilter)
      sortOrder[Name] = sortOrder[Name] === 'up' ? "down" : 'up'
      if (this.state.searchRegion === true)
        this.setState({memberDisplay: Display, searchMemberRegion: SortedResult, sortFilter: sortOrder})
      else
        this.setState({memberDisplay: Display, member: SortedResult, sortFilter: sortOrder})
    }

    _getAllNextNoneMember = async () => {
      this.setState({loadingMore: true}, async() => {
        await this.sleep(150)
        var cookies = new Cookies();
        var Jwt = cookies.get('acces');
        var Params = {
            Jwt: Jwt,
            SizeImage: "Small",
        }
        if (this.state.Filter.length !== 0)
          Params.RegionFrontend = this.state.Filter
        var promise = await Requestdynamic('_getAllNextNoneMember', Params)
        if(promise.error === false && promise.data.error === false)
        {
          var MemberCopy = [...this.state.member];
          var newListMember = MemberCopy.concat(promise.data.data)
          newListMember = [...new Set(newListMember)]
          var MemberDisplay = newListMember.slice(0, 20)
          var paramsSetState = {memberDisplay: MemberDisplay, member: newListMember, MemberDelete: null, statusDelete: null, delete: false}
          this.setState(paramsSetState)
        }
        else {
          if (promise.error === true)
            this.setState({title: 'Error', openModal: true, message: "Un problème est survenue veuillez réesayer plus tard", LastKey: false, MemberDelete: null, statusDelete: null, delete: false})
          else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true){
            cookies = new Cookies();
            cookies.remove('acces', { path: '/' })
            cookies.remove('infoAdmin', { path: '/' })
            await this.sleep(900)
            var url = '/login'
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            return ;
          }
          else
            this.setState({title: 'Error', openModal: true, message: "Un problème est survenue veuillez réesayer plus tard", LastKey: false, MemberDelete: null, statusDelete: null, delete: false})
        }
        this.setState({loadingMore: false})
      })

    }

    _addAllNextMember = async () => {
      this.setState({loadingMore: true}, async() => {
        var Copy;
        if (this.state.search != null)
           Copy = [...this.state.searchMember]
        else if (this.state.searchRegion === true)
            Copy = [...this.state.searchMemberRegion]
        else
           Copy = [...this.state.member]

        var CopyDisplay = [...this.state.memberDisplay];

        var Length = Copy.length
        var LengthDisplay = CopyDisplay.length

        if (LengthDisplay >= Length)
        {
          this.setState({loadingMore: false})
          return ;
        }
        var CopySplice = Copy.slice(LengthDisplay, LengthDisplay + 20)
        var Display = CopyDisplay.concat(CopySplice)
        Display = [...new Set(Display)]
        this.setState({loadingMore: false, memberDisplay: Display})
        return ;
      })
    }

    componentDidMount(){
      this._getAllNextNoneMember()
    }

     sleep = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    search = (value) => {
      var Copy, Display;
      var Verify;
      if (this.state.searchRegion === true)
        Verify = "searchMemberRegion"
      else
        Verify = "member"

      if (value.length === 0)
      {
        Copy = [...this.state[Verify]];
        Display = Copy.slice(0, 20)
        this.setState({search: null, memberDisplay: Display, searchMember: []})
      }
      Copy = [...this.state[Verify]];
      var FilterResult = Copy.filter(res => res.Email.toLowerCase().includes(value.toLowerCase()) || res.FirstName.toLowerCase().includes(value.toLowerCase()) || res.LastName.toLowerCase().includes(value.toLowerCase()))
      Display = FilterResult.slice(0, 20)
      this.setState({search: value, memberDisplay: Display, searchMember: FilterResult})
    }

    handleScroll = (e) => {
      var verify;
      if (this.state.search === null && this.state.searchRegion === false)
         verify = 'member'
      else if (this.state.search != null)
         verify = 'searchMember'
      else
        verify = 'searchMemberRegion'

      const bottom = e.target.scrollHeight - e.target.scrollTop - 50 <= e.target.clientHeight;
      if (bottom && this.state.memberDisplay.length !== this.state[verify].length && this.state.loadingMore === false) {
        this._addAllNextMember()
      }
    }

    _DeleteUser = async (member) => {
      if (this.state.delete === true)
      {
        this.setState({statusDelete: "Waiting"}, async () => {
          var cookies = new Cookies();
          var Jwt = cookies.get('acces');
          var Params = {Jwt: Jwt, Id: this.state.MemberDelete.Id}
          var promise = await Requestdynamic('_deleteNonMember', Params)
          if (promise.error === false && promise.data.error === false){
            this.setState({statusDelete: "Success"}, async () => {
              var Copy = [...this.state.member]
              var IndexCopy = Copy.findIndex(res => res.Id === this.state.MemberDelete.Id)
              Copy.splice(IndexCopy, 1)
              var CopyDisplay = [...this.state.memberDisplay]
              var IndexCopyDisplay = CopyDisplay.findIndex(res => res.Id === this.state.MemberDelete.Id)
              CopyDisplay.splice(IndexCopyDisplay, 1)
              await this.sleep(500)
              this.setState({statusDelete: null, member: Copy, memberDisplay: CopyDisplay, delete: false, MemberDelete: null})
            })
            return ;
          }
          else {
            if (promise.error === true)
              this.setState({statusDelete: "Error"})
            else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true)
            {
              cookies = new Cookies();
              cookies.remove('acces', { path: '/' })
              cookies.remove('infoAdmin', { path: '/' })
              await this.sleep(900)
              var url = '/login'
              const link = document.createElement('a');
              link.href = url;
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
              return ;
            }
            else
              this.setState({statusDelete: "Error"})
          }
        })
      }
      else {
        this.setState({delete: true, statusDelete: "Ask", MemberDelete: member})
        return ;
      }

    }


 render() {

   return (
     <div style={{marginLeft: 10, overflowY: "auto"}} onScroll={this.handleScroll}>
     <PopUp openModal={this.state.openModal} message={this.state.message} title={this.state.title} refParent={this}/>
     <ModalDeleteUser refParent={this} openModal={this.state.delete} statusDelete={this.state.statusDelete} MemberDelete={this.state.MemberDelete}/>
     <Header searchRegion={this.state.searchRegion} searchMemberRegion={this.state.searchMemberRegion} Member={this.state.member} Filter={this.state.Filter} intl={this.props.intl} refParent={this}/>
     <Container fluid>
      <Row>
        <Col sm={12} md={12} lg={12} xl={12} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
          <div style={{width: "100%", display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
            <SimpleButton  to={{
            pathname: `/add_none_member/`,
            state: {}
            }} component={Link}>
              <Typography style={{fontWeight: 'bold', fontSize: '15px', color: 'white'}}>Ajouter un non membre</Typography>
            </SimpleButton>
          </div>
        </Col>
        <Col sm={12} md={12} lg={12} xl={12} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '5px', marginBottom: '5px'}}>
          <ExcelFile data={this.state.member}/>
        </Col>
      </Row>
     </Container>
     <Table loadingMore={this.state.loadingMore} intl={this.props.intl} refParent={this} memberDisplay={this.state.memberDisplay} deleting={this.state.deleting} member={this.state.member}/>
     <Loading loadingMore={this.state.loadingMore}/>
    </div>
   )
 }
}


export default AllNoneMember;
